import { render, staticRenderFns } from "./ArchiveFund.vue?vue&type=template&id=5afc74b1&scoped=true&lang=pug&"
import script from "./ArchiveFund.vue?vue&type=script&lang=js&"
export * from "./ArchiveFund.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveFund.scss?vue&type=style&index=0&id=5afc74b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc74b1",
  null
  
)

export default component.exports